import React from 'react';
import * as Styles from './styles';
import { TMessage } from '../../../store/sockets/types';
import moment from 'moment';
import { IconLogoAdmin } from '../../svgs/IconLogoAdmin';
import { parseEmoji } from '../../../utils/parseEmoji';
import { TPrivateMessage } from '../../../store/privateChat/types';

export type TUserMessType = 'my' | 'admin' | 'lector' | 'user';

interface MessageProps {
  message: TMessage | TPrivateMessage;
  type: TUserMessType;
  isPinned?: boolean;
  likeMessage?: (messageId: number) => void;
}

export const Message: React.FC<MessageProps> = React.memo(({ message, type, isPinned, likeMessage }) => {
  const isMy = type === 'my';
  const isAdmin = type === 'admin';
  const isLector = type === 'lector';

  return (
    <Styles.MainWrapperS isPinned={isPinned} isMy={isMy} isAdmin={isAdmin} isLector={isLector}>
      {isAdmin ? (
        <Styles.WrapperImageS isAdmin={isAdmin}>
          <Styles.LogoWrapperS>
            <IconLogoAdmin />
          </Styles.LogoWrapperS>
        </Styles.WrapperImageS>
      ) : (
        <Styles.WrapperImageS isMy={isMy} isAdmin={isAdmin} isLector={isLector}>
          {message.name.split(' ')[0][0].toUpperCase()}
          {message.name.split(' ')[1][0].toUpperCase()}
        </Styles.WrapperImageS>
      )}
      <Styles.WrapperS>
        <Styles.NameWrapperS>
          {isMy ? null : <Styles.NameS>{isAdmin ? 'Експертус' : message.name} </Styles.NameS>}
          <Styles.TimeS> {moment(message.adate).format('DD.MM.YYYY, HH:mm')}</Styles.TimeS>
          <Styles.WrapperBtnS>
            <span>{message.countLike}</span>
            {likeMessage && (
              <button onClick={() => likeMessage(message.absnum)}>
                <i className="bi bi-hand-thumbs-up-fill" />
              </button>
            )}
          </Styles.WrapperBtnS>
        </Styles.NameWrapperS>
        {message.comment ? (
          <Styles.ReplyWrapperS>
            <Styles.ReplyHeaderS>
              <Styles.IconS>
                <i className="bi bi-reply"></i>
              </Styles.IconS>
              <Styles.NameS>{message.comment.name}</Styles.NameS>
            </Styles.ReplyHeaderS>
            <Styles.ReplyTextS dangerouslySetInnerHTML={{ __html: parseEmoji(message.comment.message) }} />
          </Styles.ReplyWrapperS>
        ) : null}

        <Styles.MessageS dangerouslySetInnerHTML={{ __html: parseEmoji(message.message) }} />
      </Styles.WrapperS>
    </Styles.MainWrapperS>
  );
});
